import { ExclamationCircleIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useDeleteLensTopics } from "../../api/BlueprintsApi";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../../shared-components/Button";
import ErrorMessageContainer from "../../shared-components/ErrorMessageContainer";
import { Modal } from "../../shared-components/Modal";

type Props = {
  lensTopicsUUID: string;
  onRemove: (lensTopicsUUID: string) => void;
};

const LensTopicsRemove = ({ lensTopicsUUID, onRemove }: Props) => {
  const [showModal, setShowModal] = useState(false);
  const {
    isLoading: isDeleteLoading,
    mutate: deleteLensTopics,
    error: errorDelete,
    isSuccess: isSuccessDelete,
  } = useDeleteLensTopics();

  useEffect(() => {
    if (isSuccessDelete) {
      setShowModal(false);
      onRemove(lensTopicsUUID);
    }
  }, [lensTopicsUUID, isSuccessDelete, onRemove]);

  function handleClose() {
    setShowModal(false);
  }

  function handleRemove() {
    deleteLensTopics(lensTopicsUUID);
  }

  return (
    <div>
      <TrashIcon
        className="w-4 cursor-pointer"
        onClick={() => {
          setShowModal(true);
        }}
      />
      <Modal open={showModal} onClose={handleClose} width={"w-104 p-3"}>
        <div>
          <div className="flex gap-4 mb-4">
            <div className="flex justify-center w-9 h-9 rounded-full bg-red-100">
              <ExclamationCircleIcon className="w-6 text-red-500" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-bold mb-2">Remove Topics?</span>
              <span className="text-sm text-gray-400">
                Removing this group will detach it from its behavior kit.
              </span>
            </div>
          </div>
          {errorDelete && (
            <ErrorMessageContainer message="Couldn't delete lens topics" />
          )}
          <div className="flex gap-4 justify-end">
            <Button
              text={"Cancel"}
              colorType={ButtonColorTypes.cancel}
              onClick={handleClose}
            />
            <Button
              type={isDeleteLoading ? ButtonTypes.saving : ButtonTypes.default}
              text="Ok"
              colorType={ButtonColorTypes.secondary}
              onClick={handleRemove}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LensTopicsRemove;
